import { App } from './app.class';
import { Modal } from './modal.class';
import { Fetch } from '../fetch.class';

export class Page {

    constructor() {

        // Elemente
        this.$form = document.querySelector('form');
        this.$errorbox = document.querySelector('div.errorbox');
        this.$container = document.querySelector('div.conta');

        // Event: Absenden des Formulars
        this.$form.addEventListener('submit', event => {
            event.preventDefault();

            var $form = event.currentTarget;

            // Sendebutton deaktivieren
            App.setSubmitBtnLoading($form);

            // Übermittlung
            const formData = new FormData($form);
            new Fetch().post(App.getUrl('account', 'passreset'), formData)
            .then(response => {

                // Fehlermeldung ausblenden
                this.$errorbox.classList.add('hidden');

                // Formular zurücksetzen
                $form.reset();

                // Erfolgsmeldung
                new Modal('#modal-sent').show();
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                var $cont = this.$errorbox.querySelector('.cont');
                $cont.innerHTML = error.message;
                this.$errorbox.classList.remove('hidden');

                // Box schütteln
                App.animateCSS(this.$container, 'shake');
            })
            .finally(() => {

                // Sendebutton zurücksetzen
                App.setSubmitBtnActive($form);
            });
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('account-passreset')) {
        new Page();
    }
});